import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

// Define the base endpoint for location
const LOCATION_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.LOCATION,
  false // No tenant ID in the base URL
);

export const getStateData = ({ countryId }) =>
  client.get(`${LOCATION_BASE}/list?level_type=2&parent_id=${countryId}`);

export const getDistrictData = ({ stateId }) =>
  client.get(`${LOCATION_BASE}/list?level_type=3&parent_id=${stateId}`);
